<template>
  <div class="card card-body rounded-top">
    <component-table
      entityType="fee"
      :addButtonEntityId="entityId"
      :addButtonEntityType="entityType"
      :actions="actions"
      :columns="columns"
      :data="list"
      :total="count"
      @add="goToAddPage(`add${capitalize(entityType)}Fee`)"
      @edit="goToEditPage($event.id, `edit${capitalize(entityType)}Fee`)"
      @delete="showDeleteDialog($event.id)"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import ComponentTable from '@/components/table/Table';
import { listMixin } from '@/mixins/list';
import { DEFAULT_TABLE_ACTIONS } from '@/utils/constants';
import { capitalize } from '@/utils/string';

// @vuese
// Lista dyscyplin
// @group Fee
export default {
  mixins: [
    listMixin('fee', {
      listError: 'messages.fee.listError',
      getError: 'messages.fee.getError',
      added: 'messages.fee.added',
      addError: 'messages.fee.addError',
      updated: 'messages.fee.updated',
      updateError: 'messages.fee.updateError',
      deleteConfirm: 'messages.fee.deleteConfirm',
      deleted: 'messages.fee.deleted',
      deleteError: 'messages.fee.deleteError'
    })
  ],
  components: { ComponentTable },
  computed: {
    ...mapState({
      entityType: state => state.fee.entityType
    }),
    entityId() {
      return this.$route.params.teamId ? this.$route.params.teamId : this.$route.params.clubId;
    }
  },
  data() {
    return {
      columns: [{ name: 'name', displayName: 'columns.name' }],
      actions: DEFAULT_TABLE_ACTIONS
    };
  },
  methods: {
    capitalize
  }
};
</script>
